import { InvoiceSurchargeState } from 'containers/invoices/InvoicesSlice';
import React, { FC, useState } from 'react';
import AddServiceFeeSection from './AddServiceFeeSection';
import AddServiceFeeModal from './AddServiceFeeModal';
import { useAppDispatch, useAppSelector } from 'hooks';
import { RootState } from 'store/reducers';
import { NotifierTypes } from 'constants/notifierConstants';
import { showNotifier } from 'containers/app/appSlice';
import { LINE_ITEM_SOURCE } from 'constants/common';

interface AddServiceFeeWrapperProps {
  serviceFee: InvoiceSurchargeState;
  isEdit: boolean;
  selectIsServiceFeeEnabled: (state: RootState) => boolean;
  onSaveIsServiceFeeEnabled: (isServiceFeeEnabled: boolean) => void;
  isEditDisabled?: boolean;
  source: LINE_ITEM_SOURCE;
  isFromBillingTab?: boolean;
}

const AddServiceFeeWrapper: FC<AddServiceFeeWrapperProps> = ({
  serviceFee,
  isEdit,
  selectIsServiceFeeEnabled,
  onSaveIsServiceFeeEnabled,
  isEditDisabled = false,
  source,
  isFromBillingTab = false
}) => {
  const [showServiceFeeModal, toggleServiceFeeModal] = useState(false);
  const dispatch = useAppDispatch();
  const isServiceFeeEnabled = useAppSelector(selectIsServiceFeeEnabled);

  const handleEditClick = () => {
    if (isEditDisabled) {
      dispatch(
        showNotifier({
          type: NotifierTypes.WARNING,
          message: {
            primaryMessage: `Editing service fee is disabled for ${source} with paid invoice`,
            isMessageHtml: false
          }
        })
      );
      return;
    }
    toggleServiceFeeModal(true);
  };

  const closeServiceFeeModal = () => {
    toggleServiceFeeModal(false);
  };

  return (
    <>
      <AddServiceFeeSection
        serviceFee={serviceFee}
        handleEditClick={handleEditClick}
        isServiceFeeEnabled={isServiceFeeEnabled}
        isEditDisabled={isEditDisabled}
        isFromBillingTab={isFromBillingTab}
        className={isFromBillingTab ? 'border-b-0 p-3' : ''}
      />
      {showServiceFeeModal && (
        <AddServiceFeeModal
          isOpen={showServiceFeeModal}
          onClose={closeServiceFeeModal}
          serviceFee={serviceFee}
          isServiceFeeEnabled={isServiceFeeEnabled}
          isEdit={isEdit}
          onSaveIsServiceFeeEnabled={onSaveIsServiceFeeEnabled}
        />
      )}
    </>
  );
};

export default AddServiceFeeWrapper;
